module.exports = __webpack_public_path__ + "static/banner2-1a1f349e6e56120f59aadf630fc338f4.png";